import React from 'react';
import search from '../../assets/icons/search.svg';
import cancel from '../../assets/icons/trash.svg'
import { useI18n } from '../../i18n';


interface SearchInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
    iconPosition?: string;
    placeholder?: string;
    className?: string;
    onChange?: (e: any) => void;
    onClear?: () => void;
    value?: string;
}

const SearchInput = ({iconPosition = 'left', placeholder, className, onChange, onClear, value, ...rest}: SearchInputProps) => {
    const { t } = useI18n();
    const [searchValue, setSearchValue] = React.useState<string>(value || '');

    return (
        <div className={`search_bar_wrapper ${className ? className : 'p-4'}`}>
            {iconPosition === 'left' && <div className='search_icon'>
                <img src={search} alt={t('components.searchInput.searchAlt')}/>
            </div>}
            <div className='input_wrapper'>
                <input value={searchValue} className={`search_bar w-full bg-transparent text-black dark:text-neutral-300 px-1`}
                       placeholder={placeholder || t('components.searchInput.defaultPlaceholder')}
                       onChange={(e) => {
                            setSearchValue(e.target.value);
                            if (onChange) {
                                onChange(e)
                            }
                       }
                }
                />
            </div>
            {
                iconPosition === 'right' && searchValue.length > 0 ? <div className='search_icon cursor-pointer' onClick={() => {
                    // onChange && onChange({target: {value: ''}});
                    setSearchValue('')
                    onClear && onClear();
                }}>
                    <img src={cancel} alt={t('components.searchInput.clearAlt')}/>
                </div> : <div>
                    <img src={search} alt={t('components.searchInput.searchAlt')}/>
                </div>
            }
        </div>
    );
};

export default SearchInput;
